var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96191 8.3252C2.43555 8.72559 2.93359 8.43262 2.93359 7.91504V7.16309H5.31152V9.5459H4.54492C4.04199 9.5459 3.75391 10.0488 4.13477 10.5029L5.47754 12.0703C5.75586 12.4121 6.22461 12.4316 6.5127 12.0801L7.85547 10.5176C8.25586 10.0439 7.96289 9.5459 7.44531 9.5459H6.69336V7.16309H9.06641V7.91504C9.06641 8.43262 9.56445 8.72559 10.0381 8.3252L11.6006 6.9873C11.957 6.69434 11.9326 6.22559 11.5908 5.94727L10.0234 4.60449C9.56934 4.22363 9.06641 4.51172 9.06641 5.01953V5.78125H6.69336V3.39844H7.44531C7.96289 3.39844 8.25586 2.90039 7.85547 2.42676L6.5127 0.859375C6.21973 0.507812 5.75098 0.537109 5.47266 0.874023L4.13477 2.44141C3.75391 2.89551 4.04199 3.39844 4.54492 3.39844H5.31152V5.78125H2.93359V5.01953C2.93359 4.51172 2.43066 4.22363 1.97656 4.60449L0.40918 5.94727C0.0722656 6.2207 0.0380859 6.68945 0.394531 6.98242L1.96191 8.3252Z",
    fill: "#E5E4EC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMove);
export default __webpack_public_path__ + "static/media/icon-move.d1f1eaca60ae51ac08743b5cca382d8e.svg";
export { ForwardRef as ReactComponent };